__webpack_require__.p = "//static.simplebooth.com/live-feed/v1.1.5/";